import React from "react";
import { motion } from "framer-motion";

export function PageTitle({ title, subtitle, actions, icon: Icon }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-6"
    >
      <div className="flex items-center gap-3">
        {Icon && (
          <div className="w-12 h-12 rounded-2xl bg-amber-500/15 border border-amber-400/40 flex items-center justify-center">
            <Icon size={24} className="text-amber-600" />
          </div>
        )}
        <div>
          <h2 className="text-2xl sm:text-3xl font-head font-bold gold-text">{title}</h2>
          {subtitle && <p className="text-sm text-stone-500 mt-1">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
    </motion.div>
  );
}

export function GlassCard({ children, className = "", ...props }) {
  return (
    <div className={`glass rounded-2xl p-5 ${className}`} {...props}>
      {children}
    </div>
  );
}

export function EmptyState({ text = "لا توجد بيانات", icon: Icon }) {
  return (
    <div className="glass rounded-2xl py-16 flex flex-col items-center gap-3 text-stone-500">
      {Icon && <Icon size={48} className="opacity-40" />}
      <p>{text}</p>
    </div>
  );
}

export function Badge({ children, className = "" }) {
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs border ${className}`}>
      {children}
    </span>
  );
}
